<template>
  <div class="topVert" id="reseauxNumerique"
       v-if="detailReseauxNumeriqueFilter.length">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold">Proposition réseau(x) numérique(s)</h2>
    </div>
    <div class="colomn"
      v-for="(reseauxNumerique, index) in detailReseauxNumeriqueFilter"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxNumerique.libelle}}
      </h3>
      <app-carte-reseaux-Numerique :detailReseauxNumerique="reseauxNumerique"
       :markerReseauxNumeriques="markerReseauxNumeriques"/>
      <app-info-reseaux-Numerique :infoReseauxNumerique="reseauxNumerique"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import carteReseauxNumerique from './carteReseauxNumerique';
import infoReseauxNumerique from './infoReseauxNumerique';

export default {
  name: 'index',
  props: ['detailReseauxNumerique', 'adresseReseauxNumeriques'],
  components: {
    appCarteReseauxNumerique: carteReseauxNumerique,
    appInfoReseauxNumerique: infoReseauxNumerique,
  },
  data() {
    return {
      markerReseauxNumeriques: {},
    };
  },
  computed: {
    ...mapGetters(['getMaSelection']),
    detailReseauxNumeriqueFilter() {
      const data = this.detailReseauxNumerique.filter(d =>
        !d.extensionOpportunite.reseauPersoGuid);
      if (this.getMaSelection) {
        return data.filter(el => el.select);
      }
      return data;
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseReseauxNumeriques.lat !== undefined) {
        this.markerReseauxNumeriques = {
          ...this.adresseReseauxNumeriques,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxNumeriques/index.vue